import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StyledLoadingPlaceholder } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const BillingToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2.4rem;
`;

export const BillingText = styled.span<{ $active: boolean }>`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  line-height: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ $active, theme }) => ($active ? theme.colors.text.main : theme.colors.grey[500])};
`;

export const YearlySavingsTag = styled.div`
  background-color: ${({ theme }) => theme.colors.alertBanner.info};
  border-radius: 3rem;
  padding: 0.2rem 1rem;
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  line-height: 1.4rem;
  color: ${({ theme }) => theme.colors.text.main};
`;

export const PricingCardContainer = styled.div<{ $withYearlyBanner: boolean }>`
  display: flex;
  flex-direction: column;
  border: 0.2rem solid ${({ theme }) => theme.colors.primary.main};
  border-radius: ${({ $withYearlyBanner }) => ($withYearlyBanner ? '1.2rem 1.2rem 0.5rem 0.5rem' : '0.5rem')};
  background-color: ${({ theme }) => theme.colors.primary.main};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
`;

export const YearlyBanner = styled.div<{ $isDarkMode: boolean }>`
  color: ${({ theme }) => theme.colors.black};
  padding: 0.2rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
`;

export const BannerText = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
`;

export const PricingContent = styled.div<{ $isDarkMode: boolean }>`
  background-color: ${({ theme, $isDarkMode }) => ($isDarkMode ? theme.colors.alertBanner.info : theme.colors.grey[100])};
  display: flex;
  flex-direction: column;
  gap: 3.2rem;
  padding: 3.2rem;
  border-radius: 0.5rem;
`;

export const PriceSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

export const PriceRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
`;

export const PriceContainer = styled.div`
  display: flex;
  gap: 0.3rem;
`;

export const OriginalPrice = styled.div`
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: 3rem;
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  color: ${({ theme }) => theme.colors.text.secondary};
  text-decoration: line-through;
  margin-right: 1rem;
`;

export const CurrencySign = styled.span`
  font-size: 6rem;
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const PriceInteger = styled.span`
  font-size: 5.4rem;
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const PriceDecimal = styled.div`
  display: flex;
  gap: 1rem;
  padding-top: 0.6rem;
`;

export const PriceDecimalText = styled.span`
  font-size: 3rem;
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const PerMonthText = styled.span`
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: ${({ theme }) => theme.fonts.sizes.large};
  color: ${({ theme }) => theme.colors.grey[500]};
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
`;

export const BillingTextContainer = styled.div`
  padding-left: 0.8rem;
`;

export const BillingDescription = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  color: ${({ theme }) => theme.colors.text.lighter};
`;

export const FeaturesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`;

export const FeaturesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
`;

export const FeatureItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
`;

export const FeatureText = styled.span`
  font-size: 1.9rem;
  color: ${({ theme }) => theme.colors.text.main};
`;

export const CheckIcon = styled(FontAwesomeIcon)`
  color: rgba(136, 204, 20, 1);
  font-size: 2.1rem;
  font-weight: 900;
`;

export const StarIcon = styled(FontAwesomeIcon)`
  font-size: 1.3rem;
`;

export const LoadingCard = styled.div`
  ${StyledLoadingPlaceholder}
  width: 100%;
  height: 40rem;
  border-radius: 0.5rem;
`;
